import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
    const raw = localStorage.getItem("token");
    let token = null;
    try { token = raw ? JSON.parse(raw) : null; } catch {}

    const socket = openSocket(getBackendUrl(), {
        transports: ["websocket", "polling"],
        query: { token },
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 60000,
    });

    // Always use the latest token when reconnecting so that an
    // access-token refresh that happened between connects is picked up.
    socket.io.on("reconnect_attempt", () => {
        const r = localStorage.getItem("token");
        try {
            socket.io.opts.query = { token: r ? JSON.parse(r) : null };
        } catch {}
    });

    return socket;
}

export default connectToSocket;
